import { type IUpdatePasswordDto, type IAuthDto } from '@App/types/authType'
import { API_URL, ADMINS_URL } from '@Config/config'

import instance from '../instance'

export class AuthController {
    onGetTokenByCreds(dto: IAuthDto) {
        return instance.post(`${API_URL}${ADMINS_URL}/sign-in`, dto)
    }

    onGetUserData() {
        return instance.get(`${API_URL}${ADMINS_URL}/admin-data`)
    }

    onSignOut() {
        return instance.get(`${API_URL}${ADMINS_URL}/sign-out`)
    }

    onChangeAdminPassword(dto: IUpdatePasswordDto) {
        return instance.post(`${API_URL}${ADMINS_URL}/change-password`, dto)
    }

    onRefreshAccessToken(accessToken: string) {
        return instance.post(`${API_URL}${ADMINS_URL}/token-refresh`, { accessToken })
    }
}
